<!-- src/components/Header.vue -->
<template>
  <header class="header">
    <div class="nav">
      <div class="logo" @click="goToHome">
        <img src="@/assets/common/logo.png" alt="Logo" class="logo-image" />
        <span class="logo-text">洛洛崽~成窝买</span>
      </div>
      <div class="search">
        <input type="text" placeholder="搜索宠物" class="search-input" />
        <button class="search-button">搜索</button>
      </div>
      <div class="buttons">
        <button class="join-button" @click="goToStoreJoin">商家入驻</button>
        <button class="about-button" @click="goToAboutUs">关于我们</button>
      </div>
    </div>
  </header>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "HeaderComponent",
  setup() {
    const router = useRouter();

    const goToStoreJoin = () => {
      router.push({ name: "StoreJoin" });
    };

    const goToAboutUs = () => {
      router.push({ name: "AboutUs" });
    };

    const goToHome = () => {
      router.push({ name: "HomeView" });
    };

    return {
      goToStoreJoin,
      goToAboutUs,
      goToHome,
    };
  },
};
</script>

<style scoped>
/* Header 样式 */
.header {
  background-color: #ffc800; /* 黄色背景 */
  color: #fff; /* 白色文字 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 78%;
  padding: 0 20px;
  height: 60px;
}

.logo {
  margin-left: 25%;
  display: flex;
  align-items: center;
}

.logo-image {
  margin-right: 5px;
  height: 30px;
}

.logo-text {
  font-size: 18px;
  font-weight: bold;
}

.search {
  display: flex;
  align-items: center;
}

.search-input {
  padding: 10px 20px;
  margin-right: 0px;
  border: none;
  background-color: #fff;
  color: #000;
  border-radius: 4px;
}

.search-button {
  padding: 5px 10px;
  border: none;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
}

.buttons {
  display: flex;
  align-items: center;
}

.join-button,
.about-button {
  padding: 5px 10px;
  border: none;
  background-color: #fff;
  color: #ffc800;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 30px;
}

.about-button {
  margin-left: 30px;
}
</style>
